import { render, staticRenderFns } from "./preContract.vue?vue&type=template&id=71a8b615&scoped=true&"
import script from "./preContract.vue?vue&type=script&lang=js&"
export * from "./preContract.vue?vue&type=script&lang=js&"
import style0 from "./preContract.vue?vue&type=style&index=0&id=71a8b615&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8b615",
  null
  
)

export default component.exports